<div id="claim-tracker">
	<claim-tracker-header></claim-tracker-header>
	<claim-tracker-breadcrumbs></claim-tracker-breadcrumbs>
	<claim-tracker-page-level-message></claim-tracker-page-level-message>
	<main>
		<div [@routeFade]="getRouteAnimationData()">
			<router-outlet></router-outlet>
		</div>
	</main>
	<claim-tracker-footer></claim-tracker-footer>
</div>
